import { render, staticRenderFns } from "./login.vue?vue&type=template&id=7afd5064&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=7afd5064&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afd5064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7afd5064')) {
      api.createRecord('7afd5064', component.options)
    } else {
      api.reload('7afd5064', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=7afd5064&scoped=true&", function () {
      api.rerender('7afd5064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/login.vue"
export default component.exports